import { createApp, defineAsyncComponent } from 'vue';
import { createI18n } from 'vue-i18n';

import i18nMessages, { registerI18n } from 'dashboard/i18n';
import * as Sentry from '@sentry/vue';
import { sentryOptions } from 'shared/helpers/sentry';
import {
  initializeAnalyticsEvents,
  initializeConversateEvents,
} from 'dashboard/helper/scriptHelpers';
import App from '../v3/App.vue';
import router, { initalizeRouter } from '../v3/views/index';
import store from '../v3/store';
// The FluentIcon component carries the full dashboard icon dictionary (~112KB of
// JSON). No auth view renders it, so it is registered lazily rather than pulling
// that dictionary into every login page load. Callers that do use <fluent-icon>
// still work; they just pay for the chunk on first render.
// import { emitter } from '../shared/helpers/mitt';

// [VITE] This was added in https://github.com/chatwoot/chatwoot/commit/b57063a8b83c86819bd285f481298d7cd38ad50e
// Commenting it out for Vite migration
// Vue.config.env = process.env;

const i18n = createI18n({
  legacy: false, // https://github.com/intlify/vue-i18n/issues/1902
  locale: 'en',
  fallbackLocale: 'en',
  messages: i18nMessages,
});
registerI18n(i18n);

const app = createApp(App);
app.use(i18n);
app.use(store);
app.use(router);

// Vue.use(VueRouter);
// Vue.use(VueI18n);
// Vue.prototype.$emitter = emitter;
app.component(
  'fluent-icon',
  defineAsyncComponent(
    () => import('shared/components/FluentIcon/DashboardIcon.vue')
  )
);
// Keep the guest bearer URL out of analytics and error-reporting SDKs.
const isConferenceGuest = /^\/app\/conferences\/join\//i.test(
  window.location.pathname
);

if (window.errorLoggingConfig && !isConferenceGuest) {
  Sentry.init(sentryOptions({ app, router, dsn: window.errorLoggingConfig }));
}

initializeConversateEvents();
if (!isConferenceGuest) {
  initializeAnalyticsEvents();
}
initalizeRouter();

window.onload = () => {
  app.mount('#app');
};
